import React, {useState, useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import { Icon, Label, Popup, Modal, Button, Form, Input } from 'semantic-ui-react'
import {WindowURL,WindowLocation,WindowReload, RootURL, WindowLocationRootURL, ImagesURL} from '../../config/settings'
import Alertmessage from '../../config/alert'
import Logo from '../../../assets/images/logo.png'

export default function WebsiteMenu(props) {


  /*

  const [alert,setalert] = useState(false);
  const [Alertcontent,setAlertcontent] = useState({});
  function Alertclose(){setalert(false);}
  function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
  function Alertdelete(data){
    if(data.delete==true){
    }
  }

  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const [toggle, settoggle] = useState(false);
  function ToggleMenu(menu){
    if(menu){
      settoggle(false);
    }else{
      settoggle(true);
    }
  }

  function SearchFunction(str){
    if(str==''){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Error Search!',html:"Input search cannot be empty."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
      return false;
    }
    WindowLocationRootURL('/search/search.php?query='+str+'&search=1');
  }

  const [data, setdata] = useState('');
  function handleChange(e){
    if(e.target.value!=''){
      setdata(e.target.value);
    }
  }

  /*-------------------------------------
		Content
	--------------------------------------*/
	/*const [content, setcontent] = useState({
    header: {
      speak: '',
      search:'',
    },
    slide:{
      heading1: '',
      heading2:'',
      subheading:'',
    }
  });
	function ContentApplication(){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					header: {
						speak:  obj.header.speak,
						search: obj.header.search,
					},
          slide:{
            heading1: obj.slide.heading1,
            heading2:obj.slide.heading2,
            subheading:obj.slide.subheading,
          }
				});
				setalert(false);
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


  useEffect(()=>{
		ContentApplication();
	},[]);*/

	return (
    <React.Fragment>
		<div className="topmenu-wrapper">
			<div className="menu-section">
			 <div className="menu-wrapper">
					<div className="menu-container wrapper-grid">
							<div><a href={RootURL('/')}><img src="https://primecapitalmarkets.net/assets/images/logo.png"/></a></div>
							<div className="menu-navigation">
									<div className="mobile-menu">
										<button className="ui labeled icon button primary" id="toggle-menu"><i className="bars icon"></i>MENU</button>
									</div>
									<ul>
										<li><a href={RootURL('/')}>Home</a></li>
										<li className="hasdropdown">
											<a>About</a>
											<ul>
												<li><a href={RootURL('/about.php')}>About Us</a></li>
												<li><a href={RootURL('/our-team.php')}>Our Team</a></li>
											</ul>
										</li>
										<li><a href={RootURL('/investment-approach.php')}>Investment Approach</a></li>
										<li><a href={RootURL('/contact-us.php')}>Contact</a></li>
										<li>
											<a href={RootURL('/application/member-login')}><button className="ui tiny primary button"><i className="lock icon"></i>Login</button></a>
										</li>
									</ul>
							</div>
					 </div>
				</div>
			</div>
		</div>
		<div className="page-header-wrapper" style={{
			backgroundImage: "url(" + RootURL('/assets/images/headerAbout.jpg') + ")",
		  backgroundPosition: 'center',
		  backgroundSize: 'cover',
		  backgroundRepeat: 'no-repeat',
			paddingTop:'100px'
		}}>
		  <div className="wrapper-grid">
		   <div className="wrapper-page-title right">
		     <div className="page-title">
		        <h2>Open Account</h2>
		     </div>
		   </div>
		 </div>
		</div>
    </React.Fragment>
	)
}
